import {css} from "lit";

export const sidebarOnboardingHelpStyles = [css`
	.msg-help {
		box-sizing: border-box;
		margin: 45px 28px;
		padding: 32px 24px;
		background-color: var(--pn-color-white);
		text-align: left;
		border: 1px solid var(--pn-outline-annotation-border-color);
	}

	.msg-sidebar-help-inner {
		margin: 0;
		font-size: var(--pn-font-size-base);
	}

	.msg-help-header {
		margin-bottom: 24px;
		color: var(--pn-outline-help-header-text-color);
		font-family: var(--pn-headings-font-family);
		font-size: var(--pn-font-size-large);
		text-align: center;
	}

	ul {
		list-style: none;
		padding: 0;
		margin-bottom: 30px;
	}

	li {
		position: relative;
		margin-bottom: 23px;
		padding-left: 60px;
		color: var(--pn-outline-help-li-text-color);
		font-size: var(--pn-font-size-base);
		line-height: 1.7;
	}

	li:last-child {
		margin-bottom: 0;
	}
	
	span.icon {
		position: absolute;
		top: 0;
		left: 0;
		background-color: var(--pn-outline-help-icon-bg-color);
		font-size: 47px;
		width: 45px;
		height: 45px;
		mask-size: 45px;
		mask-repeat: no-repeat;
	}

	i[class^="icon-"] {
		position: absolute;
		top: 0;
		left: 0;
		background-color: var(--pn-outline-help-icon-bg-color);
		font-size: 46px;
	}

	.ext-icon-highlight-text {
		top: 4px;
	}

	.msg-help li strong {
		font-weight: normal;
		color: var(--pn-outline-help-header-text-color);
	}

	.msg-help a {
		color: var(--pn-color-link);
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		height: 45px;
		width: auto;
	}
`];
